import { Injectable } from "@angular/core";
import { rate, draft, fullModel, quickQuote, CompanyCode, CompanyName, effectiveDate, expirationDate, auditFrequency, underwriterCode, BusinessName, InsuredType, yearsOfOperation, City, Line1, StateCode, StateDesc, ZipCode, ContactName, Phone1, ProducerCode, producerOfRecord, EMail, primaryState, liabMedicalExpensLmt, prodCompleteOperAggLmt, liabMedicalExpAggLmt, medicalExpensPerPerson, liabilityDeduApp, liabilityDeductibleType, liabilityDeductible, blanketRating, equipmentBreakdown, cEmpPracLiab, cEpliLimDed, cDoesLocMtf, CNoEmpMore, CNoEmpLess, cIsCyberCov, cCyberOption, cCyberCovLimit, fuelTank, CBlgExtRepCc, CExtRpCcOptions, cContraEnhaEndorsement, selfStorgFacilEnd, residCleanServCovAp, employeeDishonesty, electronicData, forgeryOrAlteration, interruptionCompOper, businessIncome, hireNonownAutoLiab, hireNonownAutoLiabCov, hireAutoNonownLiabType, hiredAutoLiabLimit, nonownedAutoLiabLmt, nonOwnedAutoLiabCov, compAndFundTranFrd, moldFungiWetDryRot, apartLosDamCusAuto, resLossDamCustAuto, contractorsEndorsement, terrorismCoverage, leadPoisoning, wantGenQstn, referenceObjectId, copyMailingAddress, description, incLmtFireDeptSc, outdoorSigns, moneyAndSecurity, empDishonestyApp, moldFungWetDryRtAp, wtrBckupSmpOvrfl, apartBuildCov, restaurantsCov, locationId, cMortgageInfo, RentalProperty, BuildingDescription, PropertyType, BuildingSquareFootage, ConstructionType, ResAuRepMnufcProcOcup, BldOwnrAndSoleOccupant, NumberOfEmployees, DistanceFromFireStation, DistToNearestHydrant, PublicProtFireClas, autoSprinkleredSystem, Interest, OwnerOccupiedSqFtge, cRatingBasis, YearBuilt, cEffectiveAgeOfBldg, cRoof, cElectrical, cWaterHeater, cHeating, cPlumbing, NumberOfUnits, NumberOccupiedByOwners, NumberLeasedToOthers, NumberVacant, IsThereABasement, PercentFinished, BldReplacementCostEst, cReconstrConstr, resAuRepMnufcProcOcup, fireAlarmALocalAlarm, fireAlarmACenStnAlarm, fireAlarmAHrdwrSmkDet, fireAlarmABatopSmkDet, cBurglarLocal, cBurgCentral, BldDeadboltDoorLocks, bldAnyOtherProtection, leadPoisoningAppl, supplLeadPoisonAppl, fuelTankApplies, dmgPremisesRentYou, dmgPremRentYouSelCov, dmgPremRentYouLimit, swimmingPool, cBusinessIncExcl, offPrmBsnsInter, windstormOrHailExcl, optionalBldgDedu, OptionalPropertyDedu, windstrmHailPrcntDed, autoIncInInsurance, spoilage, comCondUntOwner, condominComUntOwnr, foodContamination, timeElement, directDamage, vacancyPermitEndors, lossPayableClauses, earthquakeCoverage, BuildingLimitInsurance, includedBlanketRating, incRebudExpFollDis, greenUpgrades, ordinanceLaw, whRoofSurfaceLoss, ltCovAcvBldRc, debrisRemAddInsEndt, ClassCode, BusinssPersonalPropLmt, liabilityExposure, AreaOccupied, ClassificationPercen, cTenanatRelExp, utlSrvcDirectDmgApp, electronicDataCovApp, intOfCompOprCovApp, incLmtAccountsRecv, incLmtDpndntProp, incLmtPaperRecord, incLmtOutdoorProp, specBppTmpAwayFrmPrm, theftLimitations, brandsAndLabels, permYardsMaintainStr, seasonalIncPercentage, spoilageCovApp, earthquakeCovApplies, eqSprinklerLeakage, medExpensExclusion, amdAggLmtInsrnPrOb, interest, line1, line2, city, stateCode, zipCode, interestName, BusinessDesc, otherLocations, CSelectSubmission, cCompPolicy, namePriorInsurer, PriorInsPremium, ListOfPolicies, recentPolCancld, CCompPolicyType, CCompPolicyNumberRef, InsuredConst, AddressConst, ContactConst, ProducerConst, BusinessOwnersConst, enhancerEndorsement, cEnhancerPlusEndt, BPLocationsConst, name, BPInlineOBJConst, BPBuildingConst, building, businessPersonalProp, BPBuildingCoverageConst, BPClassificationsConst, classificationDesc, BPOptionalRTCCoveragesConst, BPAdditionalInsured, AdditionlInterestAddress, BPAdditionalInsuredLocations, BPCompanionPolicy, LosseHistory, foreignProducts, BPGeneralQuestionsMUConst, quotePolicy, CExtendednamedinsured1, Extendednamedinsured1, BPLossHistoryGeneralQuestionsConst, CrmProtAlmACenStAlm, CrmProtAlmALocalAlm, BPIRPMRating, ProvideBreak, StateName, BPIRPMRatingLevel, FactorType, IrpmCovUk, OverrideModifier, TotalModifier, BPIRPMOverridefactors, UnderwriterRiskConcern, RiskFactor, OverrideReason, OverrideValue, IndRiskPremiumMod, cSmallContractor, NoOfUnitsLetterCntrl, CDescProducts, LeadPoisonYrConst, BldgPropertyType, LiquorSales } from "@app/contractor.constant";

import { MercantileRequest } from "@app/interfaces/others/mercantile.modal";

@Injectable({
  providedIn: "root",
})
export class MercantileDataService {
  constructor() { }

  mercantileData: MercantileRequest = {
    [rate]: "Y",
    [draft]: "N",
    [fullModel]: "Y",
    [quickQuote]: "N",
    [quotePolicy]: {
      [CompanyCode]: "80",
      [CompanyName]: "MAPFRE Insurance Company",
      [effectiveDate]: "",
      [expirationDate]: "",
      [auditFrequency]: "Non-Auditable",
      [underwriterCode]: "",
      [InsuredConst]: {
        [BusinessName]: "",
        [InsuredType]: "",
        [yearsOfOperation]: "",
        [AddressConst]: {
          [City]: "",
          [Line1]: "",
          [line2]: "",
          [StateCode]: "",
          [StateDesc]: "",
          [ZipCode]: "",
        },
        [ContactConst]: {
          [ContactName]: "",
          [Phone1]: "",
          [EMail]: "",
        },
        [Extendednamedinsured1]: {
          [CExtendednamedinsured1]: ''
        }
      },
      [ProducerConst]: {
        [ProducerCode]: "",
        [producerOfRecord]: "",
        [ContactConst]: {
          [ContactName]: "",
          [EMail]: "",
          [Phone1]: "",
        },
      },
      [BusinessOwnersConst]: {
        [primaryState]: "Massachusetts",
        [liabMedicalExpensLmt]: "1000000",
        [prodCompleteOperAggLmt]: "2000000",
        [liabMedicalExpAggLmt]: "2000000",
        [medicalExpensPerPerson]: "5000",
        [liabilityDeduApp]: "N",
        [blanketRating]: "N",
        [IndRiskPremiumMod]: "Y",
        [equipmentBreakdown]: "Y",
        [cEmpPracLiab]: "Y",
        [cEpliLimDed]: "25000",
        [cDoesLocMtf]: "N",
        [CNoEmpMore]: "",
        [CNoEmpLess]: "",
        [cIsCyberCov]: "",
        [cCyberOption]: "",
        [cCyberCovLimit]: "",
        [fuelTank]: "N",
        [CBlgExtRepCc]: "",
        [CExtRpCcOptions]: "",
        [enhancerEndorsement]: "Y",
        [cEnhancerPlusEndt]: "",
        [cContraEnhaEndorsement]: "",
        [selfStorgFacilEnd]: "N",
        [residCleanServCovAp]: "N",
        [employeeDishonesty]: "N",
        [electronicData]: "N",
        [forgeryOrAlteration]: "N",
        [interruptionCompOper]: "N",
        [businessIncome]: "N",
        [hireNonownAutoLiab]: "",
        [hireNonownAutoLiabCov]: "",
        [hireAutoNonownLiabType]: "Both",
        [hiredAutoLiabLimit]: "",
        [nonownedAutoLiabLmt]: "",
        [nonOwnedAutoLiabCov]: "",
        [compAndFundTranFrd]: "N",
        [moldFungiWetDryRot]: "N",
        [apartLosDamCusAuto]: "N",
        [resLossDamCustAuto]: "N",
        [contractorsEndorsement]: "N",
        [terrorismCoverage]: "Y",
        [leadPoisoning]: "N",
        [wantGenQstn]: "Y",
        [BPLocationsConst]: [{
          [referenceObjectId]: "1",
          [copyMailingAddress]: "",
          [name]: "",
          [description]: "",
          Address: {
            [City]: "",
            [Line1]: "",
            [StateCode]: "MA",
            [StateDesc]: "Massachusetts",
            [ZipCode]: "",
            [cSmallContractor]: ""
          },
          [BPInlineOBJConst]: {
            [incLmtFireDeptSc]: "N",
            [outdoorSigns]: "N",
            [moneyAndSecurity]: "N",
            [empDishonestyApp]: "N",
            [moldFungWetDryRtAp]: "N",
            [wtrBckupSmpOvrfl]: "N",
            [apartBuildCov]: "N",
            [restaurantsCov]: "N",
          },
        }],
        [BPBuildingConst]: [{
          [locationId]: "1",
          [building]: "",
          [businessPersonalProp]: "",
          [cMortgageInfo]: "",
          [BldgPropertyType]: "Mercantile Risks",
          [RentalProperty]: "",
          [BuildingDescription]: "",
          [PropertyType]: "",
          [BuildingSquareFootage]: "",
          [ConstructionType]: "",
          [ResAuRepMnufcProcOcup]: "N",
          [NumberOfEmployees]: "0",
          [DistanceFromFireStation]: "",
          [DistToNearestHydrant]: "",
          [PublicProtFireClas]: "",
          [autoSprinkleredSystem]: "",
          [Interest]: "",
          [OwnerOccupiedSqFtge]: "",
          [cRatingBasis]: "Replacement Cost",
          [YearBuilt]: "",
          [cEffectiveAgeOfBldg]: "",
          [cRoof]: "",
          [cElectrical]: "",
          [cWaterHeater]: "",
          [cHeating]: "",
          [cPlumbing]: "",
          [NumberOfUnits]: "",
          [NumberOccupiedByOwners]: "",
          [NumberLeasedToOthers]: "",
          [NumberVacant]: "",
          [IsThereABasement]: "N",
          [PercentFinished]: "",
          [BldReplacementCostEst]: "",
          [cReconstrConstr]: "",
          [resAuRepMnufcProcOcup]: "N",
          [fireAlarmALocalAlarm]: "",
          [fireAlarmACenStnAlarm]: "",
          [fireAlarmAHrdwrSmkDet]: "",
          [fireAlarmABatopSmkDet]: "",
          [CrmProtAlmALocalAlm]: "",
          [CrmProtAlmACenStAlm]: "",
          [BldDeadboltDoorLocks]: "Y",
          [bldAnyOtherProtection]: "N/A",
          [leadPoisoningAppl]: "",
          [NoOfUnitsLetterCntrl]: "0",
          [LeadPoisonYrConst]: "After 1978",
          [supplLeadPoisonAppl]: "",
          [fuelTankApplies]: "N",
          [dmgPremisesRentYou]: "Y",
          [dmgPremRentYouSelCov]: "Basic",
          [dmgPremRentYouLimit]: "50000",
          [swimmingPool]: "N",
          [cBusinessIncExcl]: "N",
          [offPrmBsnsInter]: "N",
          [windstormOrHailExcl]: "N",
          [optionalBldgDedu]: "Y",
          [OptionalPropertyDedu]: "500",
          [windstrmHailPrcntDed]: "",
          [autoIncInInsurance]: "",
          [spoilage]: "N",
          [comCondUntOwner]: "",
          [condominComUntOwnr]: "",
          [foodContamination]: "N",
          [timeElement]: "N",
          [directDamage]: "N",
          [vacancyPermitEndors]: "N",
          [lossPayableClauses]: "N",
          [earthquakeCoverage]: "N",
          [BldOwnrAndSoleOccupant]: "N",
          [BPBuildingCoverageConst]: {
            [BuildingLimitInsurance]: "",
            [includedBlanketRating]: "N",
            [incRebudExpFollDis]: "N",
            [greenUpgrades]: "N",
            [ordinanceLaw]: "N",
            [whRoofSurfaceLoss]: "N",
            [ltCovAcvBldRc]: "N",
            [debrisRemAddInsEndt]: "N",
          },
          [BPClassificationsConst]: {
            [ClassCode]: "",
            [classificationDesc]:"",
            [BusinssPersonalPropLmt]: "",
            [liabilityExposure]: "150000",
            [AreaOccupied]: "Percentage",
            [ClassificationPercen]: "100",
            [cTenanatRelExp]: "N",
            [includedBlanketRating]: "N",
            [greenUpgrades]: "N",
            [utlSrvcDirectDmgApp]: "N",
            [electronicDataCovApp]: "N",
            [intOfCompOprCovApp]: "N",
            [incLmtAccountsRecv]: "N",
            [incLmtDpndntProp]: "N",
            [incLmtPaperRecord]: "N",
            [incLmtOutdoorProp]: "N",
            [specBppTmpAwayFrmPrm]: "N",
            [theftLimitations]: "N",
            [brandsAndLabels]: "N",
            [permYardsMaintainStr]: "N",
            [seasonalIncPercentage]: "25",
            [spoilageCovApp]: "N",
            [earthquakeCovApplies]: "N",
            [eqSprinklerLeakage]: "N",
            [medExpensExclusion]: "N",
            [amdAggLmtInsrnPrOb]: "Y",
          },
        }],
        [BPOptionalRTCCoveragesConst]: [],
        [BPIRPMRating]: [
          {
            [ProvideBreak]: "Y", // backend default
            [StateName]: "Massachusetts", // backend default
            [BPIRPMRatingLevel]: [
              {
                [FactorType]: "Both Combined", // backend default
                [IrpmCovUk]: "MA-Both Combined-Both Combined", // backend default
                [OverrideModifier]: "",
                [TotalModifier]: "",
              },
            ],
            [BPIRPMOverridefactors]: [
              {
                [FactorType]: "", //backend default
                [UnderwriterRiskConcern]: "",
                [RiskFactor]: "",
                [OverrideReason]: "",
                [OverrideValue]: "",
                [TotalModifier]: "",
              }
            ],
          },
        ],
        [BPGeneralQuestionsMUConst]: {
          [BusinessDesc]: "",
          [otherLocations]: "",
          [CSelectSubmission]: "New Business Policy to MAPFRE",
          [cCompPolicy]: "N",
          [namePriorInsurer]: "Other",
          [PriorInsPremium]: "0",
          [ListOfPolicies]: "",
          [recentPolCancld]: "",
          [BPCompanionPolicy]:
          {
            [CCompPolicyType]: "",
            [CCompPolicyNumberRef]: "",
          },
          [LosseHistory]: "",
          [LiquorSales]: "",
          [foreignProducts]: "",
          [CDescProducts]:"",
          [BPLossHistoryGeneralQuestionsConst]: [],
        },
      },
    },
  };
}
